import * as React from "react";
import { Themes, ThemeVariants } from "../../../theme/_Types";
import { Logo } from "./Logo";
import "../../../../src/assets/stylesheets/libs/core/03-base/loader.scss";
/**
 *
 * @param props
 */
export var PreLoader = function (props) { return (React.createElement("div", { className: "scl-preloader__wrapper ".concat(props.force ? "scl-preloader__wrapper-forcedshow" : "") },
    React.createElement("div", { className: "scl-preloader" },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement(Logo, { theme: Themes.CLAUDE, variant: ThemeVariants.CONTRAST })))); };
